/** @typedef {import("./types/kivoFeature").Permission} Permission*/

function parseTruthyEnv(raw, defaultWhenUnset = true) {
  const value = raw == null || String(raw).trim() === '' ? (defaultWhenUnset ? 'true' : 'false') : String(raw).trim();
  return ['1', 'true', 'yes', 'on'].includes(value.toLowerCase());
}

/** Compile-time Kivo integration switch. Unset/empty defaults to ON. */
export function isKivoFeatureEnabledFromEnv() {
  return parseTruthyEnv(process.env.REACT_APP_KIVO_FEATURE_ENABLE, true);
}

/**
 * Backend master switch from GET /permissions feature_flags.kivo (default ON until flags load).
 * ---------------------------------------------------------------------------------------------
 * 
 * @param {Permission} permissions 
 * @returns {boolean}
 */
export function isKivoFeatureEnabled(permissions) {
  if (!permissions?.feature_flags) return true;
  return permissions.feature_flags.kivo === true;
}

/**
 * Company pickers use kivo_config only when both frontend env and backend flag are on.
 * -----------------------------------------------------------------------------------
 * 
 * @param {Permission} permissions 
 * @returns {boolean}
 */
export function shouldUseKivoConfigSource(permissions) {
  return isKivoFeatureEnabledFromEnv() && isKivoFeatureEnabled(permissions);
}

/** Login-only compile-time flag. Unset/empty defaults to shown. */
export function isKivoSignInEnabled() {
  return parseTruthyEnv(process.env.REACT_APP_KIVO_SIGN_IN_ENABLED, true);
}
